module.exports = __webpack_public_path__ + "img/8.4fae0b23.jpg";